import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatIconModule } from '@angular/material/icon';

import { ElementsModule } from '../../../../core/elements/elements.module';
import { AppConstants } from '../../../../app.constants';
import { PlaylistItemBorderSettings } from '../../../../core/models/view-models/playlist-item-models/playlist-item-border-settings.model';

@Component({
  selector: 'modal-configure-item-border',
  templateUrl: './modal-configure-item-border.component.html',
  styleUrls: ['./modal-configure-item-border.component.scss'],
  standalone: true,
  imports: [
    MatCheckboxModule,
    MatTabsModule,
    MatSliderModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    FormsModule,
    ElementsModule
  ]
})
export class ModalConfigureItemBorderComponent {
  border: PlaylistItemBorderSettings;

  onSliderKeyDown(event: KeyboardEvent) {
    const inputEl = event.target as HTMLInputElement;
    const propertyName = inputEl.id;
    const maxValue = inputEl.max;
    let inputValue = inputEl.value.replace(AppConstants.ZERO_NUMBERS_REGULAR, '');

    if (inputValue.match(AppConstants.VALID_NUMBERS_REGULAR)) {
      inputValue = +inputValue > +maxValue ?
        maxValue :
        inputValue;
    } else {
      inputValue = this.border[propertyName];
    }

    (event.target as HTMLInputElement).value = inputValue;
    this.border[propertyName] = +inputValue;
  }

  onInputFocusOut(event: KeyboardEvent): void {
    const inputEl = event.target as HTMLInputElement;
    const propertyName = inputEl.id;

    this.border[propertyName] = this.border[propertyName] || +inputEl.min;
  }

  toggleBorder(isChecked: boolean) {
    this.border.Size = isChecked ?
      AppConstants.MCL_BORDER_MIN_WIDTH :
        AppConstants.MCL_BORDER_DISABLED_WIDTH;
  }
}
